import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FilterWithSearchMulti from './FilterWithSearchMulti';
import ClientField from '../../recordDetail/fields/ClientField';

import { clientRenderer as renderer } from '../../recordDetail/client/ClientView';

import '../Filter.css';

class FilterWithClientSearchMulti extends FilterWithSearchMulti {
  static get propTypes() {
    return {
      filterKey: PropTypes.string,
      setDisplayFilter: PropTypes.func,
      filterValue: PropTypes.any,
      onFetchClients: PropTypes.func,
      onFilter: PropTypes.func,
      label: PropTypes.string.isRequired,
      recentlyUsed: PropTypes.array,
      recentlyUsedKey: PropTypes.string
    };
  }

  findSelectionInValues(selected) {
    const { propertyName } = this.props;
    const { values } = this.state;
    return values.findIndex(val => val[propertyName] === selected[propertyName]);
  }

  onRemoveAllSelections() {
    this.setState({ values: [], value: undefined });
  }

  onAddSelection(selected) {
    const { values } = this.state;
    let newValues = values.concat();
    const index = this.findSelectionInValues(selected);
    if (index !== -1) {
      newValues.splice(index, 1, selected);
    } else {
      newValues = newValues.concat(selected);
    }
    // Add new value and reset the selection
    this.setState({ values: newValues, value: undefined });
  }

  renderSelectedList() {
    const { values } = this.state;
    const selections = (values.map((val, index) =>
      (<div className="FilterValueItem clientItem" key={this.key(index)}>
        <button
          className="remove-filter-selection"
          onClick={() => this.onRemoveSelection(val)}
        />
        <span className="filter-selected-value">
          {renderer(val)}
        </span>
      </div>)
    ));

    if (selections.length < 2) return selections;

    const clear = (<div className="FilterValueItem clear">
      <button
        className="remove-filter-selection clear"
        onClick={() => this.onRemoveAllSelections()}
        title="Click to clear selections"
      />
    </div>);

    return [clear, ...selections];
  }

  renderFilterBody() {
    const { filterKey, onFetchClients } = this.props;
    const { value } = this.state;

    return (
      <div className="Filter-body">
        <ClientField
          onFetchClients={(input, type) => onFetchClients(input, type)}
          className={classnames('Filter-client-search', `select-filter-${filterKey}`)}
          editing
          name={`filter-${filterKey}`}
          onChange={selected => this.onAddSelection(selected)}
          value={value}
          filterField
        />
        {this.renderSelectedList()}
      </div>
    );
  }
}

export default FilterWithClientSearchMulti;



// WEBPACK FOOTER //
// ./src/filter/filterTypes/FilterWithClientSearchMulti.js